var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createStore, createHook } from 'react-sweet-state';
import { addTourToCart, searchNewTourCards, searchTours } from 'api-ito/ToursApi';
import { appUrl } from 'utils';
import { makeNewTourSearchQueryFromURLParams, makeSearchId, makeSearchQueryFromURLParams } from './utils';
import { tourDetailsUrlRR } from '../tour-urlgen';
export const TourSearchStoreActions = {
    /**
     * Выполняет поиск туров с указанными параметрами.
     */
    search: (page, force = false) => ({ setState, getState }) => __awaiter(void 0, void 0, void 0, function* () {
        const prevState = getState();
        if (prevState.loading)
            return;
        const searchId = makeSearchId(prevState.searchQuery || {}, page);
        if (!force && searchId === prevState.searchId)
            return;
        setState({ loading: true, errors: [], page });
        const result = yield searchTours(Object.assign(Object.assign({}, prevState.searchQuery), { page }));
        const newState = { loading: false, searchId };
        if (!('errors' in result)) {
            const searchResult = result;
            setState(Object.assign(Object.assign({}, newState), { searchResult, pageCount: searchResult.pageCount, errors: [] }));
        }
        else {
            setState(Object.assign(Object.assign({}, newState), { errors: result.errors }));
        }
    }),
    searchURLParams: (query, force = false) => ({ getState, setState, dispatch }) => {
        const prevState = getState();
        if (prevState.loading)
            return;
        const [searchQuery, page] = makeSearchQueryFromURLParams(query);
        setState({ searchQuery });
        dispatch(TourSearchStoreActions.search(page, force));
    },
    searchNewTourURLParams: (query, force = false) => ({ getState, setState, dispatch }) => {
        const prevState = getState();
        if (prevState.loading)
            return;
        const [searchQuery, page] = makeNewTourSearchQueryFromURLParams(query);
        setState({ searchQuery });
        dispatch(TourSearchStoreActions.searchNewTourCards(page, force));
    },
    searchNewTourCards: (page, force = false) => ({ setState, getState }) => __awaiter(void 0, void 0, void 0, function* () {
        const prevState = getState();
        if (prevState.loading)
            return;
        const searchId = makeSearchId(prevState.searchQuery || {}, page);
        if (!force && searchId === prevState.searchId)
            return;
        setState({ loading: true, errors: [], page });
        const result = yield searchNewTourCards(Object.assign(Object.assign({}, prevState.searchQuery), { pageIndex: page }));
        const newState = { loading: false, searchId };
        if (!('errors' in result)) {
            const searchResult = result;
            setState(Object.assign(Object.assign({}, newState), { searchResult, pageCount: searchResult.pageCount, errors: [] }));
        }
        else {
            setState(Object.assign(Object.assign({}, newState), { errors: result.errors }));
        }
    }),
    /**
     * Генерирует ссылку на описание тура.
     */
    genTourDetailsUrl: (variantId, accmmdId, tourName, hash, search) => {
        return ({ getState }) => {
            var _a, _b, _c;
            const { searchResult, searchQuery } = getState();
            const state = {
                searchQuery: searchQuery || {},
                searchResult: {
                    totalCount: (_a = searchResult === null || searchResult === void 0 ? void 0 : searchResult.totalCount) !== null && _a !== void 0 ? _a : 0,
                    searchCountry: (_b = searchResult === null || searchResult === void 0 ? void 0 : searchResult.searchCountry) !== null && _b !== void 0 ? _b : '',
                    searchLocation: (_c = searchResult === null || searchResult === void 0 ? void 0 : searchResult.searchLocation) !== null && _c !== void 0 ? _c : '',
                }
            };
            const tourId = parseInt(variantId.split('.', 2)[0]);
            if (!tourId)
                return { hash: '#bad-params' };
            return tourDetailsUrlRR(tourId, { tourName, accmmdId, variantId, state, hash: hash !== null && hash !== void 0 ? hash : '', search: search });
        };
    },
    /**
     * Бронирует тур и при успешном завершении операции переходит в корзину.
     * @param tourVariantId Бронируемый тур
     * @param accmdVariants Выбранный вариант размещения на каждый период проживания (все периоды
     * в туре должны быть заполнены иначе это ошибка).
     */
    book: (tourVariantId, accmdVariantIds, hash, replaceExistingTour, options) => {
        return ({ getState, setState }) => __awaiter(void 0, void 0, void 0, function* () {
            const { booking } = getState();
            if (booking)
                return;
            /*
            const { adC: adultCount, chC: childCount, chA: childAges } = searchQuery as
                { adC: number, chC: number, chA: number[] };
            const ages = childAges && childAges.slice(0, Math.max(0, childCount)) || [];
            */
            setState({ booking: true, bookingErrors: [] });
            const errors = yield addTourToCart({ tourVariantId, accmdVariantIds, hash, externalFlight: undefined, separatedFlights: [], extras: undefined, replaceExistingTour, replaceCart: options === null || options === void 0 ? void 0 : options.replaceCart });
            if (!errors) {
                if (options === null || options === void 0 ? void 0 : options.onSuccess)
                    options.onSuccess();
                setState({ booking: false, bookingErrors: [] });
                window.location.href = appUrl("/Cart");
            }
            else {
                if (options === null || options === void 0 ? void 0 : options.onError)
                    options.onError(errors);
                setState({ booking: false, bookingErrors: errors });
            }
        });
    },
};
export const TourSearchStore = createStore({
    name: 'TourSearchStore',
    initialState: {
        booking: false,
        bookingErrors: [],
        errors: [],
        loading: false,
        loadingTourDetails: false,
        page: 0,
        pageCount: 0,
        searchQuery: {},
        searchResult: undefined,
        searchId: undefined,
    },
    actions: TourSearchStoreActions,
});
export const useTourSearchStore = createHook(TourSearchStore);
